import { Accessibility, CalendarCheck, Clock, Flame, MapPin, PawPrint, Sandwich, SquareParking } from "lucide-react";
import { t } from "@/lib/i18n";
import { Pending, UnverifiedTag } from "@/components/Pending";

export const VISIT_ICONS = {
  address: MapPin,
  opening_hours: Clock,
  entrance_parking: SquareParking,
  visit_arrangement: CalendarCheck,
  pet_policy: PawPrint,
  outside_food_policy: Sandwich,
  fire_bbq_rules: Flame,
  accessibility: Accessibility,
};

export default function VisitCard({ fieldKey, state, headingLevel = 3 }) {
  const H = `h${headingLevel}`;
  const Icon = VISIT_ICONS[fieldKey];
  return (
    <article className="h-full rounded-2xl bg-white border border-line p-6 lg:p-7 transition-shadow duration-300 hover:shadow-[0_12px_40px_-20px_rgba(30,58,43,0.35)]" data-testid={`visit-card-${fieldKey}`}>
      <div className="flex items-center gap-3 mb-4">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-forest/[0.07] text-forest">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        <H className="text-xl sm:text-2xl font-semibold text-wood">{t(`ziyaret.fields.${fieldKey}`)}</H>
      </div>
      {state.usable ? (
        <div className="space-y-2">
          <p className="text-[15px] leading-relaxed text-ink whitespace-pre-line" data-testid={`visit-card-${fieldKey}-value`}>{state.value}</p>
          {!state.verified && <UnverifiedTag />}
        </div>
      ) : (
        <Pending testId={`visit-card-${fieldKey}-pending`} />
      )}
    </article>
  );
}
